import React from 'react';
import { List } from 'framework/list';
import useReconciliationService from 'domain/finance/costAccounting/reconcilation/useReconciliationService';
import ReconciliationListDataContext from 'domain/finance/costAccounting/reconcilation/List/ReconciliationListDataContext';
import { DATE_FORMAT } from 'framework/utils';
import moment from 'moment';

const ReconciliationListPage = () => {
  const { search } = useReconciliationService();
  const currentMonthStart = moment().startOf('month').format(DATE_FORMAT.API_ONLY_DATE);
  const currentMonthEnd = moment().endOf('month').format(DATE_FORMAT.API_ONLY_DATE);

  return (
    <List
      getDataMethod={search}
      defaultFilter={{
        period: {
          ge: currentMonthStart,
          le: currentMonthEnd,
        },
      }}
      uncontrolledFilters={['period']}
      shouldSaveUncontrolledFilters
    >
      <ReconciliationListDataContext />
    </List>
  );
};

export default ReconciliationListPage;
